// modifer: styles/jss/nextjs-material-kit-pro/pages/loginPageStyle
import {
  page,
  container,
  title,
  description,
  blackColor,
  whiteColor,
  hexToRgb
} from 'styles/jss/original/base';

const styles = (theme) => ({
  page,
  card: {
    padding: '30px 0',
    justifyContent: 'center'
  },
  cardFooter: {
    display: 'flex',
    justifyContent: 'center',
    '@media (max-width: 768px)': {
      flexDirection: 'column'
    }
  },
  flexItem: {
    margin: '0 2px',
    '@media (max-width: 768px)': {
      width: '200px',
      margin: '0 0 10px'
    }
  },
  container: {
    ...container,
    zIndex: '4',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '100px'
    }
  },
  description: {
    ...description,
    padding: '0 0 20px',
    textAlign: 'center'
  },
  pageHeader: {
    color: whiteColor,
    border: '0',
    height: '100%',
    margin: '-60px 0 0',
    display: 'flex!important',
    padding: '120px 0',
    position: 'relative',
    minHeight: '100vh',
    alignItems: 'center',
    '&:before': {
      background: 'rgba(' + hexToRgb(blackColor) + ', 0.5)'
    },
    '&:before,&:after': {
      position: 'absolute',
      zIndex: '1',
      width: '100%',
      height: '100%',
      display: 'block',
      left: '0',
      top: '0',
      content: '""'
    }
  },
  titleLevel3: {
    ...title,
    textAlign: 'center',
    fontSize: '1.5625rem',
    '@media (max-width: 640px)': {
      fontSize: '1.3rem'
    },
    '@media (max-width: 320px)': {
      fontSize: '1.1rem'
    }
  }
});

export default styles;
